import React, { Component } from 'react';
import { Modal, Table, Radio } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';

class SelectinvestigationJdeCode extends Component {
    state = {
        visible: false,
        checked: undefined,
    }

    show = (investigationJdeContractId) => {
        const { data } = this.props;
        const checked = (data || []).findIndex(i => i.investigationJdeContractId == investigationJdeContractId);
        this.setState({
            checked,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    handleChange = (e) => {
        this.setState({ checked: e.target.value });
    }

    getColumns = () => ([
        {
            title: '',
            dataIndex: 'investigationJdeContractId',
            key: 'investigationJdeContractId',
            width: 60,
            render: (text, record, index) => {
                const { checked } = this.state; 
                return <Radio checked={checked == index} value={index} onChange={this.handleChange} />
            }
        }, {
            title: 'JDE建号申请编号',
            dataIndex: 'jdeApplyCode',
            key: 'jdeApplyCode',
            width: 120,
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 110,
        }, {
            title: '合同附件',
            dataIndex: 'contractAttachment',
            key: 'contractAttachment',
            width: 200,
            render: (text, record) => {
                const { files } = record;
                return (files || []).map(i => <a key={i.id} onClick={e => this.downLoadFile(e, i.id)}>{i.name}<br /></a>);
            }
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 90,
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            render: text => format('money', text),
        }, {
            title: '合同开始时间',
            dataIndex: 'startTime',
            key: 'startTime',
            width: 95,
        }, {
            title: '合同结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
            width: 95,
        }
    ])

    getDataSource = () => {
        const { data } = this.props;
        const dataSource = data.map(item => ({ ...item } ));
        return dataSource;
    }

    confirm = () => {
        const { checked } = this.state;
        const { data, onChange } = this.props;
        if (checked >= 0) {
            const contract = (data || [])[checked] || {};
            onChange(contract.investigationJdeContractId || undefined);
        }
        this.hide();
    }

    render() {
        const { visible } = this.state;
        return (
            <Modal
                title="选择JDE项目号"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                maskClosable={false}
                width="980px"
                zIndex={1100}
            >
                <div style={{ padding: 10 }}>
                    <Table
                        bordered
                        pagination={false}
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.investigationJdeContractId}
                    />
                </div>
            </Modal>
        );
    }
}

export default SelectinvestigationJdeCode;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/SelectinvestigationJdeCode.js